import { useState } from "react";
import styles from "./FeedbackPage.module.css";

export default function FeedbackPage() {
  const [formData, setFormData] = useState({
    category: "",
    priority: "",
    subject: "",
    description: "",
    name: "",
    email: "",
    phone: "",
    rating: 0,
    consent: false,
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log("Feedback submitted:", formData);

      // TODO: connect API here
      setSuccess(true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.content}>
      <h2 className={styles.title}>Feedback & Support</h2>
      <p className={styles.subtitle}>
        We value your feedback. Share complaints, suggestions or report issues
        to help us improve Nessefy.
      </p>

      {success ? (
        <div className={styles.successBox}>
          <h3>✅ Feedback Submitted</h3>
          <p>Thank you for helping us improve Nessefy.</p>
        </div>
      ) : (
        <form className={styles.form} onSubmit={handleSubmit}>
          {/* Category */}
          <div className={styles.row}>
            <div className={styles.field}>
              <label>Category</label>
              <select
                name="category"
                value={formData.category}
                onChange={handleChange}
                required
              >
                <option value="">Select category</option>
                <option>Customer Complaint</option>
                <option>Bug Report</option>
                <option>Feature Request</option>
                <option>Account Issue</option>
                <option>Privacy Concern</option>
                <option>Other</option>
              </select>
            </div>

            <div className={styles.field}>
              <label>Priority</label>
              <select
                name="priority"
                value={formData.priority}
                onChange={handleChange}
                required
              >
                <option value="">Select priority</option>
                <option>Low</option>
                <option>Medium</option>
                <option>High</option>
                <option>Critical</option>
              </select>
            </div>
          </div>

          {/* Subject */}
          <div className={styles.field}>
            <label>Subject</label>
            <input
              type="text"
              name="subject"
              placeholder="Brief summary of your issue"
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>

          {/* Description */}
          <div className={styles.field}>
            <label>Description</label>
            <textarea
              name="description"
              placeholder="Explain your complaint or feedback in detail..."
              rows="6"
              value={formData.description}
              onChange={handleChange}
              required
            />
          </div>

          {/* Contact Info */}
          <div className={styles.sectionTitle}>
            Contact Details (Optional)
          </div>

          <div className={styles.row}>
            <div className={styles.field}>
              <label>Name</label>
              <input
                type="text"
                name="name"
                placeholder="Your name"
                value={formData.name}
                onChange={handleChange}
              />
            </div>

            <div className={styles.field}>
              <label>Email</label>
              <input
                type="email"
                name="email"
                placeholder="Your email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className={styles.field}>
            <label>Phone</label>
            <input
              type="text"
              name="phone"
              placeholder="Phone number"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          {/* Rating */}
          <div className={styles.field}>
            <label>How satisfied are you with Nessefy?</label>
            <div className={styles.rating}>
              {[1, 2, 3, 4, 5].map((star) => (
                <span
                  key={star}
                  className={
                    formData.rating >= star
                      ? styles.starActive
                      : styles.star
                  }
                  onClick={() =>
                    setFormData((prev) => ({
                      ...prev,
                      rating: star,
                    }))
                  }
                >
                  ★
                </span>
              ))}
            </div>
          </div>

          {/* Consent */}
          <div className={styles.checkboxField}>
            <input
              type="checkbox"
              name="consent"
              checked={formData.consent}
              onChange={handleChange}
              required
            />
            <span>
              I agree to be contacted regarding this feedback.
            </span>
          </div>

          {/* Submit */}
          <button
            className={styles.submitBtn}
            type="submit"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit Feedback"}
          </button>
        </form>
      )}
    </div>
  );
}